// extracted by mini-css-extract-plugin
export default {"melodyVideo":"SQ-z","isFullWidth":"TQ-z","landingPageVideo":"UQ-z","play":"VQ-z","iframeVideo":"WQ-z","playHidden":"XQ-z","fullwidth":"YQ-z"};